export class DragAndDropContainer {
    constructor(id, dragAndDrop) {
        this.dragAndDrop = dragAndDrop
        this.cardX = 0
        this.cardY = 0
        this.framerate = null
        this.id = id
        let _self = this
        this.dragEndCallback = () => {
            this.dragEnd(id, _self, dragAndDrop)
        }
        this.attachMouseDown(id)
        this.attachMouseUp(id)
        this.attachMouseDrag(id)
        this.attachMouseMove(id)
    }

    reInit() {
        this.attachMouseDown(this.id)
        this.attachMouseUp(this.id)
        this.attachMouseDrag(this.id)
        this.attachMouseMove(this.id)
    }

    mouseDown() {}

    getDataAttributes(el) {
        let data = {}
        for (const att of el.attributes) {
            if (att.nodeName.startsWith('data-')) {
                data[att.nodeName.replace('data-', '')] = att.nodeValue
            }
        }
        return data
    }

    dragEnd(id, _self, dragAndDrop) {
        this.cardX = 0
        this.cardY = 0
        this.framerate = null

        if (dragAndDrop.dragging === false) return
        dragAndDrop.dragging = false

        let destinationContainer = document.getElementById(dragAndDrop.destinationContainerId)

        const destinationIsEmpty = destinationContainer?.children.length <= 1 // 1 é o placeholder
        // remove placeholder
        dragAndDrop.placeholder?.remove()

        // se não chegou a iniciar...
        if (dragAndDrop.dragStarting || dragAndDrop.destinationContainerId == null) {
            dragAndDrop.initialContainerId = null
            dragAndDrop.sourceIndex = null
            this.stopFloat(dragAndDrop.currentItem)
            return
        }

        if (dragAndDrop.placeholder == null) return

        // "solta" o cartão
        if (dragAndDrop.render) {
            if (destinationIsEmpty || dragAndDrop.overlayedItem === null) {
                destinationContainer.appendChild(dragAndDrop.currentItem)
            } else {
                if (dragAndDrop.dropUpOrDown == 0) {
                    destinationContainer.insertBefore(dragAndDrop.currentItem, dragAndDrop.overlayedItem)
                } else {
                    try {
                        destinationContainer.insertBefore(dragAndDrop.currentItem, dragAndDrop.overlayedItem.nextSibling)
                    } catch (error) {
                        destinationContainer.appendChild(dragAndDrop.currentItem)
                    }
                }
            }
        }
        // determina a posição final (index) do card
        if (dragAndDrop.callback != null) {
            const origin = document.querySelector('#' + dragAndDrop.initialContainerId)
            const dest = document.querySelector('#' + dragAndDrop.destinationContainerId)
            dragAndDrop.callback({
                source: {
                    container: dragAndDrop.initialContainerId,
                    index: dragAndDrop.sourceIndex,
                    data: this.getDataAttributes(origin),
                },
                destination: {
                    container: dragAndDrop.destinationContainerId,
                    index: Array.from(dragAndDrop.currentItem.parentNode.children).indexOf(dragAndDrop.currentItem),
                    data: this.getDataAttributes(dest),
                },
                element: {
                    data: this.getDataAttributes(dragAndDrop.currentItem),
                },
            })
        }
        dragAndDrop.initialContainerId = null
        dragAndDrop.sourceIndex = null
        this.stopFloat(dragAndDrop.currentItem)
        // setTimeout(() => {
        //     if (dragAndDrop.render) {
        //         let old_element = document.getElementById(id)
        //         let new_element = old_element.cloneNode(true)
        //         old_element.parentNode.replaceChild(new_element, old_element)
        //         _self.attachMouseDown(id)
        //         _self.attachMouseDrag(id)
        //     }
        // }, 25)
    }

    attachMouseDown(id) {
        let _self = this
        let dragAndDrop = this.dragAndDrop
        document.body.addEventListener('mousedown', () => {})
        document.getElementById(id).addEventListener('mousedown', function () {})
        for (let i = 0; i < document.getElementById(id).children.length; i++) {
            document.getElementById(id).children[i].addEventListener('mousedown', function (event) {
                if (!dragAndDrop.enabled) return
                // ao iniciar o arrastar

                let elem = document.createElement('div')
                elem.style.height = this.offsetHeight + 'px'
                elem.style.width = this.offsetWidth + 'px'
                if (!dragAndDrop.placeholderClass) {
                    elem.style.border = '2px dashed #99999940'
                    elem.style.marginBottom = '8px'
                    elem.style.marginTop = '8px'
                    elem.style.borderRadius = '4px'
                } else {
                    elem.classList.add(dragAndDrop.placeholderClass)
                }

                // ao iniciar o arrastar define alguns dados à instância da lib
                dragAndDrop.overlayedItemId = null
                dragAndDrop.overlayedItem = null
                dragAndDrop.dropUpOrDown = 0
                dragAndDrop.ddBlankHeight = 0
                dragAndDrop.currentItem = this
                dragAndDrop.sourceIndex = Array.from(this.parentNode.children).indexOf(this) // index do item sendo arrastado
                dragAndDrop.initialContainerId = null
                dragAndDrop.destinationContainerId = null
                dragAndDrop.placeholder = elem
                dragAndDrop.dragStarting = true

                setTimeout(() => {
                    dragAndDrop.dragging = true
                }, 10)
            })
        }
    }
    attachMouseUp(id) {
        document.body.addEventListener('mouseup', this.dragEndCallback)
        for (let i = 0; i < document.getElementById(id).children.length; i++) {
            document.getElementById(id).children[i].addEventListener('mouseup', function (event) {})
        }
    }

    attachMouseMove(id) {
        document.body.addEventListener('mousemove', (e) => this.movingEvent(this.dragAndDrop))
        for (let i = 0; i < document.getElementById(id).children.length; i++) {
            document.getElementById(id).children[i].addEventListener('mousemove', (e) => this.movingEvent(this.dragAndDrop))
        }
    }

    movingEvent(dragAndDrop) {
        if (!dragAndDrop.dragging) return
        if (dragAndDrop.callbackOnMoving) {
            let movedElement = document.getElementById()
            dragAndDrop.callbackOnMoving(dragAndDrop.currentItem)
        }
    }

    stopFloat(element) {
        element.style = ''
        element.style.display = ''
        element.style.position = ''
        element.style.pointerEvents = ''
        element.style.boxShadow = ''
        element.style.transform = ''
        element.style.marginLeft = ''
        element.style.cursor = ''
        element.style.zIndex = ''
        try {
            element.firstChild.style.marginBottom = ''
        } catch (error) {}
    }

    async startFloat(draggedItem, mouseX, mouseY) {
        // this.cardX is the point where the mouse clicks over draggedItem
        // if (this.cardX === 0) {
        //     console.log('cardX', mouseX, this.getCoords(draggedItem).left)
        //     this.cardX = mouseX - this.getCoords(draggedItem).left //draggedItem.offsetLeft
        //     this.cardY = mouseY - this.getCoords(draggedItem).top
        // }

        if (draggedItem.style.position !== 'fixed') {
            draggedItem.style.width = draggedItem.offsetWidth + 'px'
            draggedItem.style.position = 'fixed'
            draggedItem.style.pointerEvents = 'none'
            draggedItem.style.boxShadow = '20px 20px 60px rgba(0,0,0,0.3)'
            //draggedItem.style.transform = 'rotate(5deg)'
            //draggedItem.style.marginLeft = '25px'
            draggedItem.style.cursor = 'move'
            draggedItem.style.zIndex = '1'
        }

        if (this.framerate) clearTimeout(this.framerate)

        draggedItem.style.left = parseInt(mouseX - this.cardX) + 'px' //mouse position - card mouse point
        draggedItem.style.top = parseInt(mouseY - this.cardY) + 'px'
    }

    attachMouseDrag(id) {
        let dragAndDrop = this.dragAndDrop
        let _self = this
        let container = document.getElementById(id)

        // container dragOver
        container.addEventListener('mousemove', function (event) {
            let x = event.clientX
            let y = event.clientY
            // se o container não possui elementos
            if (!dragAndDrop.dragging) return
            const root = this
            if (!dragAndDrop.initialContainerId) dragAndDrop.initialContainerId = root.id
            _self.startFloat(dragAndDrop.currentItem, x, y)

            let lastItem = root.lastElementChild
            if (lastItem?.style.display === 'none') lastItem = lastItem?.previousElementSibling
            const afterLast = lastItem ? event.pageY > _self.getCoords(lastItem).top + lastItem.offsetHeight : false
            if (root.children.length <= 1 || afterLast) {
                dragAndDrop.overlayedItem = null
                if (root.children.length <= 2) {
                    dragAndDrop.dropUpOrDown = 0
                } else {
                    dragAndDrop.dropUpOrDown = 1
                }
                dragAndDrop.destinationContainerId = id
                try {
                    root.appendChild(dragAndDrop.placeholder)
                } catch (e) {}
            }
        })

        // adicionar um eventListener em cada card
        for (let i = 0; i < container.children.length; i++) {
            ;(function (index) {
                // card dragOver - este evento ocorre continuamente enquanto o cartão está sendo arrastado
                container.children[i].addEventListener('mousemove', function (event) {
                    if (!dragAndDrop.dragging) return

                    _self.startFloat(dragAndDrop.currentItem, event.clientX, event.clientY)

                    const root = this.parentNode
                    if (dragAndDrop.dragStarting) {
                        dragAndDrop.dragStarting = false
                        root.insertBefore(dragAndDrop.placeholder, dragAndDrop.currentItem)
                        if (!dragAndDrop.initialContainerId) dragAndDrop.initialContainerId = root.id
                        return
                    }

                    let overlayedItem = this
                    dragAndDrop.overlayedItem = this
                    dragAndDrop.destinationContainerId = root.id
                    dragAndDrop.overlayedItemId = index
                    if (_self.getCoords(overlayedItem).top + overlayedItem.offsetHeight / 2 > event.pageY) {
                        dragAndDrop.dropUpOrDown = 0
                        try {
                            root.insertBefore(dragAndDrop.placeholder, overlayedItem)
                        } catch (e) {}
                    } else {
                        dragAndDrop.dropUpOrDown = 1
                        try {
                            root.insertBefore(dragAndDrop.placeholder, overlayedItem.nextSibling)
                        } catch (e) {}
                    }
                })
            })(i)
        }
    }

    getCoords(elem) {
        var box = elem.getBoundingClientRect()

        var body = document.body
        var docEl = document.documentElement

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

        var clientTop = docEl.clientTop || body.clientTop || 0
        var clientLeft = docEl.clientLeft || body.clientLeft || 0

        var top = box.top + scrollTop - clientTop
        var left = box.left + scrollLeft - clientLeft

        return { top: Math.round(top), left: Math.round(left) }
    }

    remove() {
        document.body.removeEventListener('mousedown', this.mouseDown())
        document.body.removeEventListener('mouseup', this.dragEndCallback)
    }
}

/**
 * Os itens dentro do placeholder PRECISAM possuir um ID. Ex.:
 * {#each rows as row, i (row.id)}
 */
export class DragAndDrop {
    constructor(containerId = null) {
        this.dragging = false
        this.initialContainerId = null
        this.sourceIndex = null
        this.placeholder = null
        this.placeholderClass = null
        this.destinationContainerId = null
        this.overlayedItemId = null
        this.overlayedItem = null
        this.currentItem = null
        this.dropUpOrDown = 0
        this.dragStarting = false
        this.ddBlankHeight = 0
        this.callback = null
        this.render = true
        this.enabled = true
        this.callbackOnMoving = null

        if (containerId) {
            setTimeout(() => new DragAndDropContainer(containerId, this), 50)
        }
    }
    setOnMovedCallback(callback) {
        this.callback = callback
    }
    setRender(render) {
        this.render = render
    }

    setOnMovingCallback(callback) {
        this.callbackOnMoving = callback
    }
}
